// import React, { useState, useEffect } from "react";
// import CourseDetails from "./CourseDetails";
// import Header from "../Header";
// import { FetchCourseDetails } from "../../api/aws-api";
// import { ConstructorEventGet } from "../../Event/event";
// import { useLocation } from "react-router-dom";
// import { ClassicSpinner } from "react-spinners-kit";

// const Course = (props) => {
//   const location = useLocation();
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [courseProps, setCourseProps] = useState();

//   useEffect(() => {
//     const { course } = location.state ? location.state : [];
//     setCourseProps(course);
//     fetchdata(course);
//     setLoading(true);
//   }, [props]);

  

//   const fetchdata = async (course) => {
//     const temp = sessionStorage.getItem("Course" + course.course_id);
    
//     const courseid = localStorage.setItem("Course_ID",course.course_id)

//     console.log(course.course_id,"courseid")
//     const parsedTemp = temp ? JSON.parse(temp) : null;
//     if (parsedTemp) {
//       setLoading(false);
//       setData(parsedTemp);
//     }
//     const responsedata = await ConstructorEventGet(FetchCourseDetails, {
//       course_id: course.course_id,
//     });
//     setData(responsedata);
//     sessionStorage.setItem(
//       "Course" + course.course_id,
//       JSON.stringify(responsedata)
//     );
//     //const s3data = await ConstructorEventGet(FetchJsonFromS3,{bucket_name : "anglofonecoursedetails",fetchfile:responsedata[0]["course_details"]})
//     //setCoursedata(s3data)
//     setLoading(false);
//   };

//   return (
//     <>
//       <Header />

//       {/* Added spinner while changing from one course to another */}

//       {loading ? (
//         <div className="spinner">
//           <div className="spinner-wrapper">
//             <ClassicSpinner size={50} color="black" loading={props.loading} />
//           </div>
//         </div>
//       ) : (
//         <CourseDetails
//           CourseDetails={data}
//           loading={loading}
//           courseProps={courseProps}
//         />
//       )}
//     </>
//   );
// };

// export default Course;





























// import React, { useState, useEffect } from "react";
// import CourseDetails from "./CourseDetails";
// import Header from "../Header";
// import { FetchCourseDetails } from "../../api/aws-api";
// import { ConstructorEventGet } from "../../Event/event";
// import { useLocation, useNavigate } from "react-router-dom";
// import { ClassicSpinner } from "react-spinners-kit";

// const Course = (props) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [courseProps, setCourseProps] = useState();

//   useEffect(() => {
//     const { course } = location.state || {};
//     if (!course) {
//       navigate("/codomo/home");
//       return;
//     }
//     setCourseProps(course);
//     fetchdata(course);
//     setLoading(true);
//   }, [props]);
  

//     const fetchdata = async (course) => {
//     const temp = sessionStorage.getItem("Course" + course.course_id);
    
//     const courseid = localStorage.setItem("Course_ID",course.course_id)

//     console.log(course.course_id,"courseid")
//     const parsedTemp = temp ? JSON.parse(temp) : null;
//     if (parsedTemp) {
//       setLoading(false);
//       setData(parsedTemp);
//     }
//     const responsedata = await ConstructorEventGet(FetchCourseDetails, {
//       course_id: course.course_id,
//     });
//     setData(responsedata);
//     sessionStorage.setItem(
//       "Course" + course.course_id,
//       JSON.stringify(responsedata)
//     );
//     //const s3data = await ConstructorEventGet(FetchJsonFromS3,{bucket_name : "anglofonecoursedetails",fetchfile:responsedata[0]["course_details"]})
//     //setCoursedata(s3data)
//     setLoading(false);
//   };

//   return (
//     <>
//       <Header />

//       {/* Added spinner while changing from one course to another */}

//       {loading ? (
//         <div className="spinner">
//           <div className="spinner-wrapper">
//             <ClassicSpinner size={50} color="black" loading={props.loading} />
//           </div>
//         </div>
//       ) : (
//         <CourseDetails
//           CourseDetails={data}
//           loading={loading}
//           courseProps={courseProps}
//         />
//       )}
//     </>
//   );
// };

// export default Course;



























import React, { useState, useEffect } from "react";
import CourseDetails from "./CourseDetails";
import Header from "../Header";
import { FetchCourseDetails, FetchBatchData, FetchMentorDetails } from "../../api/aws-api";
import { ConstructorEventGet } from "../../Event/event";
import { useLocation, useNavigate } from "react-router-dom";
import { ClassicSpinner } from "react-spinners-kit";

const Course = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [courseProps, setCourseProps] = useState();

  useEffect(() => {
    const { course } = location.state || {};
    if (!course) {
      navigate("/codomo/home");
      return;
    }
    fetchdata(course);
    setLoading(true);
  }, [props]);


  // Picks the soonest not-yet-completed class from a batch's schedule.
  // "Upcoming" = still Scheduled/InProgress AND its start time hasn't
  // passed yet. Falls back to null if nothing qualifies (e.g. batch is
  // fully Completed/Cancelled, or has no ClassSchedule at all).
  const findNextClass = (classSchedule) => {
    if (!Array.isArray(classSchedule)) return null;

    const now = new Date();

    const upcoming = classSchedule
      .filter((c) => c && c.startDateTime && c.status !== "Completed" && c.status !== "Cancelled")
      .filter((c) => new Date(c.startDateTime) >= now)
      .sort((a, b) => new Date(a.startDateTime) - new Date(b.startDateTime));

    return upcoming.length > 0 ? upcoming[0] : null;
  };

  // Builds the next_class_details object CourseDetails/Join Now expect,
  // by combining: this course's batch schedule (for the next class time)
  // and the mentor's static meet_link (for where to actually join).
  const buildNextClassDetails = async (course) => {
    try {
      if (!course.batch_mentor_id || !course.batch_id) return null;

      const [batches, mentors] = await Promise.all([
        ConstructorEventGet(FetchBatchData, { mentorId: course.batch_mentor_id }),
        ConstructorEventGet(FetchMentorDetails),
      ]);

      const matchingBatch = Array.isArray(batches)
        ? batches.find((b) => b.BatchId === course.batch_id || b.BatchName === course.batch_id)
        : null;

      const nextClass = matchingBatch ? findNextClass(matchingBatch.ClassSchedule) : null;

      const matchingMentor = Array.isArray(mentors)
        ? mentors.find((m) => m.user_id === course.batch_mentor_id)
        : null;

      const meetLink = matchingMentor ? matchingMentor.meet_link : "";

      // Only surface a "Join Now" / schedule if there's an actual
      // upcoming class AND the mentor has a link set — showing "Join
      // Now" with nowhere to go would be worse than showing nothing.
      if (!nextClass || !meetLink) return null;

      return {
        startDateTime: nextClass.startDateTime,
        meet_link: meetLink,
      };
    } catch (err) {
      console.error("Failed to build next_class_details:", err);
      return null;
    }
  };

  const fetchdata = async (course) => {
    const temp = sessionStorage.getItem("Course" + course.course_id);

    localStorage.setItem("Course_ID", course.course_id);

    console.log(course.course_id, "courseid");
    const parsedTemp = temp ? JSON.parse(temp) : null;
    if (parsedTemp) {
      setLoading(false);
      setData(parsedTemp);
    }

    const [responsedata, nextClassDetails] = await Promise.all([
      ConstructorEventGet(FetchCourseDetails, { course_id: course.course_id }),
      buildNextClassDetails(course),
    ]);

    setData(responsedata);
    sessionStorage.setItem(
      "Course" + course.course_id,
      JSON.stringify(responsedata)
    );

    // courseProps = the original course object (batch_mentor_name etc.
    // that CourseDetails already reads) PLUS the freshly-built schedule
    setCourseProps({ ...course, next_class_details: nextClassDetails });

    setLoading(false);
  };

  return (
    <>
      <Header />

      {loading ? (
        <div className="spinner">
          <div className="spinner-wrapper">
            <ClassicSpinner size={50} color="black" loading={props.loading} />
          </div>
        </div>
      ) : (
        <CourseDetails
          CourseDetails={data}
          loading={loading}
          courseProps={courseProps}
        />
      )}
    </>
  );
};

export default Course;